export function splitSentences(text) {
  if (!text || !text.trim()) {
    return [];
  }

  const matches = text.match(/[^.!?]+[.!?]?/g);
  return (matches || [text]).map((sentence) => sentence.trim()).filter(Boolean);
}

export function tokenize(sentence) {
  if (!sentence) {
    return [];
  }

  return sentence.match(/\w+|[^\w\s]|\s+/g) || [sentence];
}
